<div class="register-template">
  <div class="filled-area">
    <ng-content class="content" select="[content]"></ng-content>
  </div>
</div>
